export const ESIGNING_STATUS =
    {
      COMPLETED: 'Signed',
      PENDING: 'Pending',
      UNSENT: 'Unsent'
    };
